<template>
  <div v-if="(isAdmin() || isManager() || isHOD()) && dashboardData.activatedModules && dashboardData.activatedModules.indexOf('branchesAct') > -1"
       class="card mb-4 branch-stats-filter">
    <div class="card-body">
      <div class="filter-row">
        <span class="filter-label"><i class="fas fa-building"></i> {{ $t('showStatsForBranches.text') }}</span>
        <div style="width: 260px; max-width: 100%;">
          <Multiselect
              v-model="selectedBranch"
              :options="selectOptions"
              mode="single"
              :closeOnSelect="true"
              :searchable="true"
              :canClear="false"
              :noOptionsText="$t('noOptionsText.text')"
              :noResultsText="$t('noResultsText.text')"
              valueProp="id"
              label="branchName"
              track-by="branchName"
              @change="onChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import {mapState} from "vuex";

export default {
  name: "branch-stats-filter",
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedBranch: null,
    }
  },
  computed: {
    ...mapState('dashboard', {
      dashboardData: 'dashboardData',
    }),
    allBranches() {
      return this.dashboardData.userBranches || [];
    },
    selectOptions() {
      if (this.allBranches.length > 1) {
        return [{id: 'all', branchName: this.$t('allBranches.text')}, ...this.allBranches];
      }
      return this.allBranches;
    },
  },
  watch: {
    'dashboardData.userActiveBranch': {
      immediate: true,
      handler(branchId) {
        if (branchId) {
          this.selectedBranch = branchId;
          this.onChange(this.selectedBranch);
        }
      },
    },
  },
  methods: {
    onChange(value) {
      const ids = value === 'all' ? this.allBranches.map(b => b.id) : [value];
      this.$emit('change', ids);
    },
  },
}
</script>

<style scoped>
.branch-stats-filter .filter-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.branch-stats-filter .filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  font-weight: 600;
  color: #6c6684;
  white-space: nowrap;
  margin: 0;
}
</style>
